import React from 'react';
import styled from 'styled-components/macro';
import { Layout } from 'components/organisms';
import {
  Title, HelperTitle, Spacer, Button
} from 'components/atoms';
import {
  SubwebsUserList, SubwebsListTable, Authenticator, SubwebCreateModal
} from 'containers'
import { injectIntl } from 'react-intl'
import { intlType } from 'types'
import { useToggle } from 'hooks';

const Page = ({ intl }) => {
  const [isOpenSubwebModal, toggleSubwebModal] = useToggle()

  return (
    <Layout>
      <Dashboard>
        <Top>
          <Dashboard.Header>
            <Title>{intl.formatMessage({ id: 'home.title' })}</Title>
          </Dashboard.Header>
          <GlobalActions>
            <Authenticator requires="admin">
              <SubwebCreateModal isOpen={isOpenSubwebModal} toggle={toggleSubwebModal} />
              <Button modifiers={['dark']} onClick={toggleSubwebModal}>
                {intl.formatMessage({ id: 'subweb.new' })}
              </Button>
              <Spacer right="xs2" />
            </Authenticator>
          </GlobalActions>
        </Top>
        <Spacer bottom="xl2">
          <HelperTitle as="h2">{intl.formatMessage({ id: 'section.quick.subweb' })}</HelperTitle>
          <SubwebsUserList />
        </Spacer>
        <Spacer bottom="xl2">
          <HelperTitle>{intl.formatMessage({ id: 'section.table.subweb' })}</HelperTitle>
          <SubwebsListTable />
        </Spacer>
      </Dashboard>
    </Layout>
  )
}

const Top = styled.div`
  padding-bottom: ${props => props.theme.spacing.xl4};
  display: flex;
  justify-content: space-between;
`

const GlobalActions = styled.div`
  display: flex;
  height: fit-content;
  a {
    text-decoration: none !important;
    font-size: ${props => props.theme.sizes.m} !important;
  }
`

const Dashboard = styled.div`
  ${HelperTitle} {
    margin-bottom: ${props => props.theme.spacing.l};
  }
`;

Dashboard.Header = styled.div`
  margin-bottom: ${props => props.theme.spacing.l};
`;


Page.propTypes = {
  intl: intlType.isRequired,
}

export default injectIntl(Page);
